import { render, staticRenderFns } from "./DressCodesTable.vue?vue&type=template&id=4ed53078&"
import script from "./DressCodesTable.vue?vue&type=script&lang=js&"
export * from "./DressCodesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports